import { useState, useMemo } from 'react'

import { useWorkspaces, useNetwork } from '@tribeplatform/react-sdk/hooks'

export function useAppSwitcherItems() {
  const [searchQuery, setSearchQuery] = useState('')
  const { data: workspaces = [], isLoading } = useWorkspaces({
    fields: {
      images: {
        darkMobileLogo: {
          onImage: {
            urls: 'all',
          },
        },
        lightMobileLogo: {
          onImage: {
            urls: 'all',
          },
        },
      },
    },
  })
  const { data: currentNetwork } = useNetwork()

  const filteredApps = useMemo(() => {
    const query = searchQuery.trim()

    const filtered = query
      ? workspaces.filter(
          workspace =>
            workspace.name.toLowerCase().includes(query.toLowerCase()) ||
            workspace.domain.toLowerCase().includes(query.toLowerCase()),
        )
      : workspaces

    if (!query && currentNetwork) {
      return [...filtered].sort((a, b) => {
        if (a.id === currentNetwork.id) {
          return -1
        }
        if (b.id === currentNetwork.id) {
          return 1
        }
        return 0
      })
    }

    return filtered
  }, [searchQuery, workspaces, currentNetwork])

  return {
    filteredApps,
    searchQuery,
    setSearchQuery,
    isLoading,
    currentNetwork,
  }
}
